module.exports = __webpack_public_path__ + "assets/media/day39.db2a2759.mp3";